import { render, staticRenderFns } from "./CultureIndex.vue?vue&type=template&id=6c9fe0d0&scoped=true"
import script from "./CultureIndex.vue?vue&type=script&lang=js"
export * from "./CultureIndex.vue?vue&type=script&lang=js"
import style0 from "./CultureIndex.vue?vue&type=style&index=0&id=6c9fe0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9fe0d0",
  null
  
)

export default component.exports